module.exports = __webpack_public_path__ + "img/fjellskredovervaakning.993e9feb.jpg";